module.exports = __webpack_public_path__ + "media/checkmarks/checkmark--green-area-8525a5ee.svg";